import { ReactElement } from 'react';

import styles from './AutomaticChip.module.scss';

const AutomaticChip = (): ReactElement => <span className={styles.chip}>Automatic</span>;

export default AutomaticChip;
